import { PurchaseFormData } from "./PurchaseForm";
import { ShipmentFormData } from "./ShipmentForm";

export const EMPTY_SHIPMENT: ShipmentFormData = {
  shipmentNumber: "",
  shipFromLocation: "",
  purchaseOrderNumber: "",
  status: "",
  issueDate: null,
  freightMethod: "",
  shipmentDate: null,
  estimatedDeliveryDate: null,
  actualDeliveryDate: null,
  destinationName: "",
  destinationCountry: "",
  products: [
    {
      asin: "",
      sku: "",
      title: "",
      quantity: "",
      costPerUnit: "",
    },
  ],
};

export const EMPTY_PURCHASE: PurchaseFormData = {
  supplierName: "",
  supplierId: "",
  orderNumber: "",
  status: "",
  orderDate: null,
  estimatedCompletionDate: null,
  actualCompletionDate: null,
  products: [
    {
      asin: "",
      title: "",
      sku: "",
      cost: "",
      quantity: "",
    },
  ],
};
